
// COPIES configs
const TRANSLATIONS_PREFIX_FRONT = process.env.REACT_APP_COPIES_PREFIX;
const TRANSLATIONS_PREFIX_COMMON = process.env.REACT_APP_COPIES_PREFIX_COMMON;

// TOKEN configs
const GET_CRS_DATA = () => {
  const token = window.localStorage.getItem('tokenAccess');

  const tokenData = JSON.parse(atob(token.split('.')[1]));

  const hotelId = (tokenData && tokenData.hotelCode) ? tokenData.hotelCode : '0';

  return {
    hotelId: parseInt(hotelId, 10).toString(),
    language: (tokenData && tokenData.lang) ? tokenData.lang : '',
    userName: (tokenData && tokenData.sub) ? tokenData.sub : '',
    platform: (tokenData && tokenData.platformCode)
      ? tokenData.platformCode
      : process.env.REACT_APP_PLATFORM
  };
};

// BACKEND configs
const BACKEND_URL = process.env.REACT_APP_BACK_URL;
const COPIES_URI = 'common/translate';

// FRONTEND alternative URL
const CRS_URL = process.env.REACT_APP_CRS_URL;

export {
  CRS_URL,
  GET_CRS_DATA,
  BACKEND_URL,
  COPIES_URI,
  TRANSLATIONS_PREFIX_FRONT,
  TRANSLATIONS_PREFIX_COMMON
};
